import { useAuth0 } from '@auth0/auth0-vue'

export function useAuth() {
  const { isAuthenticated, user, isLoading, logout, loginWithRedirect } = useAuth0()

  const login = async (returnTo: string) => {
    loginWithRedirect({
      openUrl(url) {
        window.location.replace(url)
      },
      appState: {
        target: returnTo,
      },
    })
  }

  return {
    isLoading,
    isAuthenticated,
    login,
    logout,
    user,
  }
}
